(function(angular) {
    /**
     * @ngdoc object
     * @name ConfirmationModalController
     * @description Confirmation modal controller
     */
    class ConfirmationModalController {
        static get $inject() {
            return ['message'];
        }

        constructor(message) {
            this.confirmationMessage = message;
        }
    }

    angular.module('wtUi')
        .controller('ConfirmationModalController', ConfirmationModalController);
})(window.angular);
